import { MutationTree } from 'vuex'
import { ISearchState } from './search-state.store';
import { SEARCH_RECIEVE, SEARCH_ASSIGN_TO_ME, SEARCH_RECIEVE_LOADING } from './search-types.store';
import { ActivityStatus } from '../../common/enums';

export const mutations: MutationTree<ISearchState> = {
  [SEARCH_RECIEVE_LOADING]: (state: ISearchState, payload: { key: string, status: string }) => {
    state.status[payload.key] = payload.status;
  }
  , [SEARCH_RECIEVE]: (state: ISearchState, payload: { key: string, metaData: any[] }) => {
    state[payload.key] = payload.metaData;
  }
}


// WEBPACK FOOTER //
// ./src/store/search/search-mutations.store.ts